import gsap, { Sine } from 'gsap'

const randomX = random(1, 10)
const randomY = random(1, 10)
// const randomDelay = random(0, 1)
const randomTime = random(3, 5)
const randomTime2 = random(5, 10)
const randomAngle = random(-10, 10)

function rotate(target, direction) {
  return gsap.to(target, {
    duration: () => randomTime2(),
    rotation: randomAngle(direction),
    // delay: randomDelay(),
    ease: Sine.easeInOut,
    onCompleteParams: [target, direction * -1],
  })
}

function moveX(target, direction) {
  return gsap.to(target, {
    x: () => randomX(direction),
    duration: () => randomTime(),
    ease: Sine.easeInOut,
    onComplete: moveX,
    onCompleteParams: [target, direction * -1],
  })
}

function moveY(target, direction) {
  return gsap.to(target, {
    duration: () => randomTime(),
    y: () => randomY(direction),
    ease: Sine.easeInOut,
    onComplete: moveY,
    onCompleteParams: [target, direction * -1],
  })
}

function random(min, max) {
  const delta = max - min
  return (direction = 1) => (min + delta * Math.random()) * direction
}

export default {
  mounted() {
    if (this.highlights) {
      const blobs = gsap.utils.toArray('.category-list__decoration > img')
      const tl = gsap.timeline()
      gsap.delayedCall(25, () => {
        // tl.pause();
      })
      blobs.forEach((can) => {
        tl.set(
          can,
          {
            x: randomX(-1),
            y: randomX(1),
            rotation: randomAngle(-1),
          },
          0
        )

        tl.add(moveX(can, 1), 0)
        tl.add(moveY(can, -1), 0)
        tl.add(rotate(can, 1), 0)
      })
    }
  },
}
